module.exports = __webpack_public_path__ + "static/img/about_fix.cbc9acb6.png";